import { Components, Theme } from '@mui/material';

const MuiPopover: Components<Theme>['MuiPopover'] = {
  styleOverrides: {
    root: {
      zIndex: 10000,
    },
  },
};

export default MuiPopover;
